import { RewardsIconSchema } from "@apps/rewards/schemas/RewardsIconSchema";
import { nullable, number, object, optional, string } from "superstruct";

export const CustomerRewardsActivitySchema = object({
    id: number(),
    title: string(),
    icon: nullable(RewardsIconSchema),
    pointsPrice: optional(number()),
});
